/**
 * Click ID parameter mappings for advertising platforms.
 * Click IDs are used for offline conversion tracking and ROAS bidding.
 */

const CLICK_ID_PARAMS_MAP: Record<string, string> = {
  gclid: "google_gclid",
  gbraid: "google_gbraid",
  wbraid: "google_wbraid",
  dclid: "google_dclid",
  fbclid: "meta_fbclid",
  msclkid: "bing_msclkid",
  ttclid: "tiktok_ttclid",
};

export interface ClickIds {
  google_gclid?: string | null;
  google_gbraid?: string | null;
  google_wbraid?: string | null;
  google_dclid?: string | null;
  meta_fbclid?: string | null;
  bing_msclkid?: string | null;
  tiktok_ttclid?: string | null;
}

/**
 * Extracts click IDs from URL query string.
 * Click IDs are case-sensitive.
 *
 * @param queryString - A query string taken from a path or URL.
 * @returns Object containing extracted click IDs
 */
export function getClickIds(queryString?: string) {
  let clickIds: ClickIds = {};

  if (!queryString) {
    return clickIds;
  }
  const params = new URLSearchParams(queryString);

  Array.from(params.keys())
    .filter(param => !!CLICK_ID_PARAMS_MAP[param])
    .forEach(param => {
      const key = CLICK_ID_PARAMS_MAP[param] as keyof ClickIds;
      clickIds[key] = params.get(param);
    });

  return clickIds;
}
